<template lang="html">
<vs-popup :active.sync="showPopup" :title="'Message à '+ getCommercialName() + '\nN° Contrat '+contract_id+ ' - ' + getSocietyName()"  :style="{ zIndex: $props.zIndex }">
         <!-- <vx-card class="mb-1"> -->
			<div class="note-form" style="display: flex; flex-direction: column;">
    <vs-textarea class="w-full" v-model="newNote"></vs-textarea>
    <vs-button ref="send-message-button" @click="addNote" style="margin-left: auto;">Envoyer</vs-button>
</div>

         <!-- </vx-card> -->
		</vs-popup>
     </template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VueCookies from "vue-cookies";
import store from "@/store/store";
export default {
	created() {
		this.consultantList = this.allCollaborators;
		store.dispatch("getAllSocieties");
		//getting orders which belongs to user sign in
	},
	components: {},
	mounted() {},
	name: "NotepadPopup",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		zIndex: {
			type: Number,
			default: 1000, // Example default z-index
		},
		popupActive: Boolean,
		contract_id: Number,
		society_id: Number,
		createdUserId: Number,
		destinationUserId: Number,
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			newNote: "",
			showPopup: this.$props.popupActive,
			notes: [],
			consultantList: [],
		};
	},
	computed: {
		allSocieties: () => {
			return store.state.societies;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		getSocietyName: function () {
			return this.allSocieties
				.filter((ele) => ele.id == this.$props.society_id)
				.map((e) => e.name);
		},
		getCommercialName: function () {
			return this.allCollaborators
				.filter((ele) => ele.id == this.destinationUserId)
				.map((e) => e.firstname + " " + e.lastname);
		},

		addNote: function () {
			if (this.newNote.trim() === "") return;
			this.setLoading(true, "send-message-button");
			// //console.log("COMEMRCIOA", this.destinationUserId);
			const body = {
				created_user_id: this.activeUser.id,
				destination_user_id: this.$props.destinationUserId,
				comment: this.newNote,
				contract_id: this.$props.contract_id,
				society_id: this.$props.society_id,
				society_name: this.getSocietyName()[0]
			};

			this.$http
				.post(this.apiUrl + "contract/addNote", body)
				.then((res) => {
					this.$vs.notify({
						title: "Succès",
						text: "Note ajouté avec succès.",
					});
					this.setLoading(false, "send-message-button");
					this.showPopup = false;
					this.$emit("close-popup");
				})
				.catch((err) => {
					this.setLoading(false, "send-message-button");
					this.$vs.notify({
						title: "Echec",
						text: "Le note n'a pas été ajouté.",
					});
				});
		},
		deleteNote: function (index) {
			this.notes.splice(index, 1);
		},
		onchangeNote(note) {
			this.newNote = note;
		},
		changeConsultant(consultant) {
			this.createdUserId = consultant;
			//console.log(consultant);
		},
	},
	watch: {},
};
</script>
